module.exports = __webpack_public_path__ + "static/index/img/baikal-500.f12f7319.jpg";